import React from "react";
import { Box, Divider, Stack, Skeleton } from "@vapor/react-material";
import { WsTag } from "@onefront/react-workspace-components";

interface SidebarSkeletonProps {
    withoutMenu?: boolean;
    n?: number;
}

export const SidebarSkeleton = ({ withoutMenu = false, n = 7 }: SidebarSkeletonProps) => {
    return (
        <Stack direction={"column"} spacing={2}>
            <Box px={4} pt={4}>
                <WsTag textColor="DarkImperialBlue" type="bodySmall500" loading />
            </Box>
            <Box px={4}>
                <Skeleton width="80%" height={67} animation={"wave"} />
            </Box>
            <Box px={4} pb={4}>
                <Stack spacing={0} direction="column">
                    <Skeleton width="80%" animation={"wave"} />
                    <Skeleton width="80%" animation={"wave"} />
                </Stack>
            </Box>
            {!withoutMenu && (
                <>
                    <Divider light />
                    <Box px={4} pt={2}>
                        <Skeleton width="40%" height={48} />
                    </Box>

                    <Box>
                        <Stack px={4} spacing={0} gap={0}>
                            {Array.from({ length: n }).map((_, i) => (
                                <Skeleton key={i} width="80%" height={30} animation={"wave"} />
                            ))}
                        </Stack>
                    </Box>
                </>
            )}
        </Stack>
    );
};
